module.exports = fox._r("fonts/throughChat.svg?exnqbq", __webpack_public_path__ + "_/_/_/root/fonts/throughChat.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/throughChat.svg?exnqbq
// module id = 451
// module chunks = 4